<template>
  <div id="signin" class="container-fluid d-flex flex-column align-items-center justify-content-center min-vh-100">
    <img src="../../assets/logo/アプリアイコン_黄グラデ_R1_収集しマース.png" fluid style="height:100px" class="m-5">

    <!-- カスタムサインインフォーム（テスト用） -->
    <div class="signin-form w-100" style="max-width: 400px;">
      <h3 class="text-center mb-4">ようこそ</h3>
      <form @submit.prevent="handleSignIn">
        <div class="mb-3">
          <input
            v-model="username"
            type="text"
            placeholder="ユーザー名を入力してください"
            required
            class="form-control"
          />
        </div>
        <div class="mb-3">
          <input
            v-model="password"
            type="password"
            placeholder="パスワードを入力してください"
            required
            class="form-control"
          />
        </div>
        <button type="submit" :disabled="isLoading" class="btn btn-primary w-100 mb-3">
          {{ isLoading ? 'サインイン中...' : 'サインイン' }}
        </button>
        <div v-if="errorMessage" class="alert alert-danger">
          {{ errorMessage }}
        </div>
      </form>
    </div>

    <div class="text-center mt-4">
      <h6 class="m-3">Powered by Panasonic ITS Co., LTD.</h6>
      <p><small class="m-3">クラウドシステム:20261029版(v1.7.2)</small></p>
      <p><small class="m-3">Webアプリ:20261030版(v1.8.3)</small></p>
      <p><small class="m-3">接続中環境 : {{l_currentEnv}}</small></p>
    </div>
  </div>
</template>

<script>
import { Auth } from 'aws-amplify';
import util from '@/common/util.js';

export default {
  name: 'Signin',
  mixins: [util],
  data() {
    return {
      username: '',
      password: '',
      isLoading: false,
      errorMessage: '',
      l_currentEnv: "N/A",
      l_currentRegion: "N/A"
    }
  },
  mounted() {
    var hostStrings = window.location.host;
    var envRegion = this.getCurrntEnvAndRegionFromURL(hostStrings)
    this.l_currentEnv = envRegion.env
    this.l_currentRegion = envRegion.region
  },
  methods: {
    async handleSignIn() {
      console.log('handleSignIn called with:', this.username);

      if (!this.username || !this.password) {
        this.errorMessage = 'ユーザー名とパスワードを入力してください';
        return;
      }

      this.isLoading = true;
      this.errorMessage = '';

      try {
        // Amplify v5.3.12認証
        const signInUser = await Auth.signIn(this.username, this.password);

        // 初回ログイン時のパスワード変更チャレンジ対応
        if (signInUser.challengeName === 'NEW_PASSWORD_REQUIRED') {
          console.log('New password required');
          this.errorMessage = '初回ログインのためパスワード変更が必要です。管理者に連絡してください。';
          return;
        }

        // 認証済みユーザー情報を取得
        const authenticatedUser = await Auth.currentAuthenticatedUser();

        // JWTトークンを取得してユーザーオブジェクトに追加
        const session = await Auth.currentSession();
        const enhancedUser = {
          ...authenticatedUser,
          signInUserSession: {
            idToken: {
              jwtToken: session.getIdToken().getJwtToken()
            }
          }
        };

        // Vuexストアに保存
        this.$store.commit('setUser', enhancedUser);
        this.$store.commit('setUserSignInStatus', true);

        // ホーム画面にリダイレクト
        console.log('Redirecting to home');
        await this.$router.push('/');

      } catch (error) {
        console.error('Sign in error:', error);
        this.errorMessage = 'サインインに失敗しました: ' + (error.message || '不明なエラー');
      } finally {
        this.isLoading = false;
      }
    }
  }
}
</script>

<style scoped>
#signin {
  text-align: center;
  white-space: pre-line;
}
</style>
